import {getFullName} from '@/scripts/utils/users.ts';
import {UserData} from '@/scripts/types/generated';

export const useAuthentication = () => {
	const $page = usePage();

	const isAuthenticated = computed(() => !!$page.props.auth.user);
	const user = computed(() => $page.props.auth.user);
	const fullName = computed(() => {
		if (!isAuthenticated) {
			return undefined;
		}

		return getFullName(user.value);
	});

	const initials = computed(() => {
		if (!user.value?.firstName && !user.value?.lastName) {
			return '-';
		}

		if (user.value?.firstName && !user.value?.lastName) {
			return user.value?.firstName.charAt(0);
		}

		if (!user.value?.firstName && user.value?.lastName) {
			return user.value?.lastName.charAt(0);
		}

		return user.value?.firstName.charAt(0) + user.value?.lastName.charAt(0);
	});

	const isCurrentUser = (member?: UserData): boolean => {
		return user.value?.uuid !== null && user.value?.uuid === member?.uuid;
	};

	return {
		isAuthenticated,
		isCurrentUser,
		user,
		fullName,
		initials,
	};
};
